function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import omit from 'lomit';
import Canvas from 'react-canvas-wrapper';

var BarIndicator = /*#__PURE__*/function (_Component) {
  _inheritsLoose(BarIndicator, _Component);

  function BarIndicator(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.draw = _this.draw.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = BarIndicator.prototype;

  _proto.draw = function draw(canvas) {
    var node = ReactDOM.findDOMNode(canvas);
    var context = node.getContext('2d');

    if (!context) {
      return;
    }

    var _this$props = this.props,
        backgroundColor = _this$props.backgroundColor,
        color = _this$props.color,
        height = _this$props.height,
        progress = _this$props.progress,
        width = _this$props.width;
    var pixelRatio = window.devicePixelRatio || 1;
    var responsiveWidth = width * pixelRatio;
    var responsiveHeight = height * pixelRatio;
    context.clearRect(0, 0, responsiveWidth, responsiveHeight);
    context.fillStyle = backgroundColor;
    context.fillRect(0, 0, width, height);

    if (progress) {
      context.fillStyle = color;
      context.fillRect(0, 0, width * progress, height);
    }
  };

  _proto.render = function render() {
    var props = omit(this.props, ['color', 'backgroundColor']);
    return React.createElement(Canvas, _extends({}, props, {
      draw: this.draw
    }));
  };

  return BarIndicator;
}(Component);

BarIndicator.propTypes = {
  progress: PropTypes.number,
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
  backgroundColor: PropTypes.string
};
BarIndicator.defaultProps = {
  progress: 0,
  width: 45,
  height: 5,
  color: 'black',
  backgroundColor: 'transparent'
};
export default BarIndicator;